import React from 'react';

export const HitType = (hit) => {
    let type = hit.eventType ?? hit.categories ?? null;

    if (Array.isArray(type)) {
        type = type.map((category, index) => [
            <span style={{ fontWeight: '700' }} key={index}>
                {category.singular}
            </span>,
        ]);
    } else {
        type = type && <span style={{ fontWeight: '700' }}>{type}</span>;
    }

    return type;
};
